import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonTitle, IonToolbar } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import { useEffect, useState } from 'react';

import { IonModalWrapper } from './OtpModal.style';
import GenerateOtpQrCode from './GenerateOtp';
import RegisterOtp from './RegisterOtp';
import { IOtpQrCode } from '../../models/portal/otp.model';
import { useAppDispatch } from '../../store/hooks';
import store from '../../store';
import { IJwt } from '../../models/portal/auth.model';
import { setTokenStoreAsync } from '../../store/authSlice';
import { useToast } from '../../providers/ToastProvider';

export interface IComponentProps {
  showModal: boolean;
  handleDismiss?: () => void;
}

enum WizardStep {
  GenerateOtp,
  RegisterOtp,
}

const OtpModal: React.FC<IComponentProps> = function ({ showModal, handleDismiss }) {
  const [wizardStep, setWizardStep] = useState<WizardStep>(WizardStep.GenerateOtp);
  const [qrCode, setQrCode] = useState('');
  const [key, setKey] = useState('');
  const [password, setPassword] = useState('');

  const dispatch = useAppDispatch();
  const {
    actions: { infoToast },
  } = useToast();

  useEffect(() => {
    if (!showModal) {
      setWizardStep(WizardStep.GenerateOtp);
    }
  }, [showModal, setWizardStep]);

  const otpQrGenerationHandled = (data: IOtpQrCode, password: string) => {
    if (data.qrCode) {
      setPassword(password);
      setQrCode(data.qrCode);
      setKey(data.key);

      setWizardStep(WizardStep.RegisterOtp);
    }
  };

  const otpRegisterHandler = async () => {
    const { token } = store.getState().auth;
    await dispatch(setTokenStoreAsync({ ...token, hasOtp: true } as IJwt));
    infoToast('Two-Step Authentication Enabled');
    handleDismiss && handleDismiss();
  };

  return (
    <IonModalWrapper
      isOpen={showModal}
      onDidDismiss={() => {
        if (showModal) {
          handleDismiss && handleDismiss();
        }
      }}>
      <IonHeader color="lightest">
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton fill="solid" onClick={() => handleDismiss && handleDismiss()}>
              <IonIcon icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Enable up two-step authentication</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent color="lightest" className="ion-padding">
        {wizardStep === WizardStep.GenerateOtp && <GenerateOtpQrCode otpQrGenerationHandled={(data, password) => otpQrGenerationHandled(data, password)} />}
        {wizardStep === WizardStep.RegisterOtp && <RegisterOtp password={password} qrCode={qrCode} privateKey={key} otpRegisterHandler={() => otpRegisterHandler()} />}
      </IonContent>
      <IonFooter></IonFooter>
    </IonModalWrapper>
  );
};

export default OtpModal;
